import React, { useState } from "react";
import { BsGeoAltFill } from "react-icons/bs";
import mapIllustration from "../Images/vintage-map.svg";

const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1607.8460645690752!2d28.17322152290796!3d36.29551939204148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14956f6dbae1eb4d%3A0x71bc50b507db3e14!2zzpXPg8-EzrnOsc-Ez4zPgc65zr8gVGhlIG9sZCBob3VzZSByZXN0YXVyYW50!5e0!3m2!1sel!2sgr!4v1681751112296!5m2!1sel!2sgr";

const Map = () => {
  // The Google Maps iframe sets Google cookies as soon as it loads, so we
  // don't load it automatically. We show a placeholder and only load the map
  // once the visitor chooses to — their click is their consent.
  const [showMap, setShowMap] = useState(false);

  return (
    <div className="find_us__map_frame">
      {showMap ? (
        <iframe
          title="The Old House location on Google Maps"
          src={MAP_SRC}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      ) : (
        <button
          type="button"
          className="find_us__map_consent"
          onClick={() => setShowMap(true)}
          aria-label="Show the map. Loads Google Maps, which may set cookies and receive your IP address."
        >
          <img
            src={mapIllustration}
            alt=""
            aria-hidden="true"
            className="find_us__map_bg"
          />
          <span className="find_us__map_scrim" aria-hidden="true" />
          <span className="find_us__map_consent_inner">
            <span className="find_us__map_pin" aria-hidden="true">
              <BsGeoAltFill size={34} />
            </span>
            <span className="find_us__map_consent_title">Show the map</span>
            <span className="find_us__map_consent_note">
              Loads Google Maps. Google may set cookies and receive your IP
              address.
            </span>
          </span>
        </button>
      )}
    </div>
  );
};

export default Map;
